(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artical-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('article-social-share')) {
    customElements.define(
      'article-social-share',
      class ArticleSocialShare extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.shareButton = this.querySelector('[data-native-share]');
          this.copyButton = this.querySelector('[data-copy-link]');
          this.status = this.querySelector('[data-share-status]');

          this.shareButton.addEventListener('click', () => this.share());
          this.copyButton.addEventListener('click', () => this.copy());
        }

        async share() {
          try {
            if (navigator.share) {
              await navigator.share({
                title: this.dataset.shareTitle,
                url: this.dataset.shareUrl,
              });

              return;
            }

            await this.copy();
          } catch (error) {
            if (error.name !== 'AbortError') {
              await this.copy();
            }
          }
        }

        async copy() {
          try {
            await navigator.clipboard.writeText(this.dataset.shareUrl);
            this.announce(this.dataset.copySuccess);
          } catch (error) {
            this.announce(this.dataset.copyError);
          }
        }

        announce(message) {
          this.status.textContent = '';

          requestAnimationFrame(() => {
            this.status.textContent = message;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
